export const CREATE_MOBILE_VERSION_REQUEST = "CREATE_MOBILE_VERSION_REQUEST";
export const CREATE_MOBILE_VERSION_SUCCESS = "CREATE_MOBILE_VERSION_SUCCESS";
export const CREATE_MOBILE_VERSION_FAIL = "CREATE_MOBILE_VERSION_FAIL";
export const RESET_CATEGORIES = "RESET_CATEGORIES";
export const FETCH_MOBILE_VERSIONS_REQUEST = "FETCH_MOBILE_VERSIONS_REQUEST";
export const FETCH_MOBILE_VERSIONS_SUCCESS = "FETCH_MOBILE_VERSIONS_SUCCESS";
export const FETCH_MOBILE_VERSIONS_FAIL = "FETCH_MOBILE_VERSIONS_FAIL";
export const UPDATE_MOBILE_VERSION_REQUEST = "UPDATE_MOBILE_VERSION_REQUEST";
export const UPDATE_MOBILE_VERSION_SUCCESS = "UPDATE_MOBILE_VERSION_SUCCESS";
export const UPDATE_MOBILE_VERSION_FAIL = "UPDATE_MOBILE_VERSION_FAIL";
export const DELETE_MOBILE_VERSION_REQUEST = "DELETE_MOBILE_VERSION_REQUEST";
export const DELETE_MOBILE_VERSION_SUCCESS = "DELETE_MOBILE_VERSION_SUCCESS";
export const DELETE_MOBILE_VERSION_FAIL = "DELETE_MOBILE_VERSION_FAIL";
